/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';
import { data } from 'componentregistry/help/sample_pages/SampleCSVData';

export const page: {
  root: Item<'Page'>;
  localDataStore: Item<'LocalDataStore'>;
  dataStoreReference: Item<'DataStoreReference'>;
  form: Item<'Form'>;
  textField: Item<'TextField'>;
  dateField: Item<'DateField'>;
  numberField: Item<'NumberField'>;
  checkbox: Item<'Checkbox'>;
  dateField1: Item<'DateField'>;
  checkbox1: Item<'Checkbox'>;
  radioBox: Item<'RadioBox'>;
  select: Item<'Select'>;
} = {
  checkbox: {
    children: [],
    itemId: 'checkbox',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Boolean' },
      viewAttribute: 'active',
    },
    type: 'Checkbox',
  },
  checkbox1: {
    children: [],
    itemId: 'checkbox1',
    parent: 'form',
    props: {
      boxLabel: { type: 'text', value: 'Box Label' },
      viewAttribute: 'someYn',
    },
    type: 'Checkbox',
  },
  dataStoreReference: {
    children: ['form'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'test',
    },
    type: 'DataStoreReference',
  },
  dateField: {
    children: [],
    itemId: 'dateField',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Date' },
      viewAttribute: 'someDate',
    },
    type: 'DateField',
  },
  dateField1: {
    children: [],
    itemId: 'dateField1',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Date Time' },
      showTime: true,
      viewAttribute: 'someDateTime',
    },
    type: 'DateField',
  },
  form: {
    children: [
      'textField',
      'dateField',
      'numberField',
      'checkbox',
      'dateField1',
      'select',
      'checkbox1',
      'radioBox',
    ],
    itemId: 'form',
    parent: 'dataStoreReference',
    props: {
      formHorizontal: true,
      labelAlignment: 'right',
      labelWidth: 120,
    },
    type: 'Form',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'test',
      data,
      dataSource: 'test',
    },
    type: 'LocalDataStore',
  },
  numberField: {
    children: [],
    itemId: 'numberField',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Number' },
      viewAttribute: 'someNumber',
    },
    type: 'NumberField',
  },
  radioBox: {
    children: [],
    itemId: 'radioBox',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Radio' },
      options: { type: 'text', value: 'Y,N' },
      viewAttribute: 'someYn',
    },
    type: 'RadioBox',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  select: {
    children: [],
    itemId: 'select',
    parent: 'form',
    props: {
      comboDatasourceAlias: 'test',
      label: { type: 'text', value: 'Select' },
      labelAttribute: 'name',
      valueAttribute: 'name',
      viewAttribute: 'name',
    },
    type: 'Select',
  },
  textField: {
    children: [],
    itemId: 'textField',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Name' },
      viewAttribute: 'name',
    },
    type: 'TextField',
  },
};
